// import WidgetAjax from './../widget/WidgetAjax';

export default class Config {
    static getBasePath() {
        // const basePath = "http://localhost:3000/DataFiberAPI";

        // const basePath = "http://218.26.73.114:18121/gradeIndividualAPI";

        // const basePath = "http://192.168.0.147:8090/gradeIndividualAPI";

        // 正式环境
        const basePath = "https://mtyx.gtgsh.com/gradeIndividualAPI";

        // 测试环境
        // const basePath = "http://121.52.209.242:23942/gradeIndividualAPI";

        return basePath;
    }

    static getTagBasePath() {
        // const basePath = "http://218.26.73.114:18121/gradeIndividualAPI";

        // 正式环境
        const basePath = "https://mtyx.gtgsh.com/gradeIndividualAPI";

        // 测试环境
        // const basePath = "http://121.52.209.242:23942/gradeIndividualAPI";

        return basePath;
    }

    static getThalassaPath() {
        // const basePath = "http://218.26.73.114:18121/gradeIndividualAPI";

        // 正式环境
        const basePath = "/grade-individual/static/attachment/";

        // 测试环境
        // const basePath = "http://121.52.209.242:23942/gradeIndividualAPI";

        return "";
    }

    static getFilePath() {

        // const basePath = "http://218.26.73.114:18121/grade-individualTest/static/attachment/";

        // 正式环境
       
        const basePath = "/grade-individual/static/attachment/";


        return basePath;
    }


    static getDBID() {
        const DBID = undefined;
        return DBID;
    }

    static getMapName() {
        return "110105";
    }

    static getEncryptyType() {
        return "MD5";
    }

    static isShowHeaderArea() {
        return false;
    }

    /**
     * 是否演示环境
     * @returns 
     */
    static isDemo() {
        // return true;
        return false;
    }


    static getSystemTitle() {
        return "个体工商户发展服务网";
    }

    static getSystemType() {
        return "sso"; // 线上
        // return "local"; // 线下
    }

    static getHermesPanoramaUID() {
        return "yx";
    }
}


